<template>
  <div class="modal" :class="{ 'is-active': showModal }">
    <div class="modal-background" @click="close()"></div>
    <div class="modal-content">
      <div class="box">
        <div id="print-receipt">
          <p class="title">{{ receipt_data.shop_name }}</p>
          <p class="subtitle">
            <span class="business-name">{{ receipt_data.name }},</span>
            <br />
            <span class="tax-id">{{ receipt_data.tax_id }}</span>
            <br />
            <span class="address">
              {{ receipt_data.address }},<br />
              {{ receipt_data.city }}
            </span>
            <br />
            <span class="phone">
              <span class="material-symbols-outlined">smartphone</span>
              {{ receipt_data.phone }}
            </span>
            <br />
            <span class="email">
              <span class="material-symbols-outlined">mail</span>
              {{ receipt_data.email }}
            </span>
          </p>
          <div class="detail">
            <p class="bill-id"># {{ bill_detail.uuid }}</p>
            <p class="date">Fecha: {{ bill_detail.created_at }}</p>
            <ol class="items">
              <li v-for="item in bill_detail.items" :key="item.timestamp">
                {{ currency(item.due) }}
              </li>
            </ol>
            <p class="total">Total: {{ currency(bill_detail.total) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { format } from "date-fns";
import * as bulmaToast from "bulma-toast";

export default {
  name: "ReceiptPrint",
  props: {
    shop: {
      type: String,
      required: true,
    },
    bill_id: {
      type: String,
      required: true,
    },
    showModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      bill_detail: {},
      receipt_data: {},
    };
  },
  mounted() {
    this.getBill().then(() => {
      this.printReceipt();
    });
  },
  methods: {
    currency(val) {
      let cur = Intl.NumberFormat("es-CO");
      return `$ ${cur.format(val)}`;
    },
    formatDate(date) {
      return format(new Date(date), "Y-MM-dd p");
    },
    close() {
      this.$emit("closeModal");
    },
    async getBill() {
      await axios
        .get(`api/v1/shop/${this.shop}/${this.bill_id}/print/`)
        .then((response) => {
          this.bill_detail = response.data.bill_detail;
          this.receipt_data = response.data.receipt_data;
          this.bill_detail.created_at = this.formatDate(
            this.bill_detail.created_at
          );
          this.bill_detail.items = this.bill_detail.items.filter(
            (i) => !i.is_deleted
          );
          this.$forceUpdate();
        })
        .catch(() => {
          bulmaToast.toast({
            message:
              "Se presento un error no es posible mostrar esta información.",
            type: "is-danger",
            position: "bottom-right",
          });
        });
    },
    printReceipt() {
      let toPrint = `
      <html>
      <head>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
        <title>Print Receipt</title>
        <style>
          body {
            font-family: sans-serif;
            width: 75mm;
          }
          .title { 
            text-align: center;
            font-size: 1.5em;
            margin-block-end: unset;
          }
          .subtitle { 
            text-align: center;
            margin-block-start: unset;
            font-size: 1em;
          }
          .business-name {}
          .tax-id {}
          .address {}
          .date {}
          .phone {}
          .email {}
          .total {
            text-align: right;
            font-weight: bolder;
            border-top: 1px gray dashed;
            padding-top: 0.5em;
          }
          .bill-id {
            border-top: 1px gray dashed;
            text-align: center;
            font-size: small;
          }
          .items {
            text-align: right;
          }
          .material-symbols-outlined{
            display: inline-flex;
            vertical-align: middle;
            font-size: larger!important;
          }
        </style>
      </head>
      <body>
        ${document.getElementById("print-receipt").innerHTML}
      </body></html>`;
      var w = window.open(
        "",
        "",
        "left=0,top=0,width=100,height=100,toolbar=0,scrollbars=0,status=0"
        // "left=0,top=0,width=600,height=300,toolbar=0,scrollbars=0"
      );
      w.document.write(toPrint);
      w.document.close();
      w.focus();
      w.print();
      w.close();
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
  font-size: 1.5em;
}
.subtitle {
  text-align: center;
  font-size: 1em;
}
.business-name {
}
.tax-id {
}
.address {
}
.date {
}
.phone {
}
.email {
}
.total {
  text-align: right;
  font-weight: bolder;
  border-top: 1px gray dashed;
  padding-top: 0.5em;
}
.bill-id {
  border-top: 1px gray dashed;
  text-align: center;
  font-size: small;
}
.items {
  text-align: right;
  padding-inline-start: revert;
}

@media print {
  body {
    visibility: hidden;
    min-height: 100vh;
  }
  body > * {
    display: hidden;
  }

  .print-receipt {
    visibility: visible;
    display: block;
    margin-top: 0px;
    margin-left: 0px;
  }
  .modal {
    justify-content: unset;
  }

  @page {
    margin: 0;
  }
}
</style>
